document.addEventListener("keydown", function(event) {

	//if a toggle key has been pressed
	if(event.keyCode == 32 || event.keyCode == 13) {

		//if this isn't a custom checkout toggle, bail
		if (!event.target.classList.contains('checkout-checkbox-toggle')) return;

		//prevent default jump
		event.preventDefault();

		//get the actual input element
		let input = event.target.previousElementSibling;

		//if we have an input
		if(input) {

			//toggle its checked status
			input.checked = !input.checked;
		}
	}
});